// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"01ac29c9","496":"848cd013","576":"ca4b2c15"}[chunkId] + ".chunk.js";
};